import { Table } from '@components/display/tables';
import { InstallationData, ISerialSubmission } from '@extendedWarranty/types/extendedWarranty';
import CheckCircleOutlinedIcon from '@mui/icons-material/CheckCircleOutline';
import { TableCell, Typography } from '@mui/material';
import { format } from 'date-fns/format';

const tableColumns = [
    { id: 'sn', label: 'Serial number' },
    { id: 'date', label: 'Installation Date' },
];

const UploadConfirmationPDF = ({
    name,
    serial_numbers,
    date_installed,
    index,
    primary,
}: Pick<InstallationData, 'serial_numbers' | 'date_installed'> & { name: string; index: number; primary: boolean }) => {
    const renderRow = (serialNumberData: Partial<ISerialSubmission>) => {
        return (
            <>
                <TableCell component="th" scope="row">
                    <Typography variant="body2" fontSize={26}>
                        {serialNumberData.SerialNumber}
                    </Typography>
                </TableCell>
                <TableCell component="th" scope="row">
                    <Typography variant="body1" fontSize={26}>
                        {format(date_installed, 'yyyy/MM/dd')}
                    </Typography>
                </TableCell>
            </>
        );
    };

    return (
        <div id={`pdf-container-${index}`} key={`pdf-${index}`} className="px-20">
            {primary && (
                <div className="flex flex-col md:flex-row md:items-center mb-5 md:mb-10 gap-5">
                    <div className="flex flex-col gap-4">
                        <Typography variant="h3" fontWeight={700}>
                            {name}
                        </Typography>
                        <div>
                            <Typography variant="h5" fontWeight={700}>
                                Installation Date
                            </Typography>
                            <Typography variant="h6" fontWeight={400}>
                                {format(date_installed, 'yyyy/MM/dd')}
                            </Typography>
                        </div>
                    </div>
                </div>
            )}
            <div>
                {primary && (
                    <div className="flex max-w-[366px] py-4 px-5 gap-5 bg-caribbean-green rounded-md">
                        <CheckCircleOutlinedIcon color="white" />
                        <div className="text-white flex flex-col gap-1 -mt-2 mb-2">
                            <Typography variant="body1" fontWeight={600}>
                                Uploaded
                            </Typography>
                            <Typography variant="body2" fontWeight={400}>
                                Serial numbers uploaded successfully.
                            </Typography>
                        </div>
                    </div>
                )}
                <Table
                    bigHeaders
                    containerClassname="bg-white"
                    headers={tableColumns}
                    onSortClick={() => {}}
                    data={serial_numbers}
                    renderRow={renderRow}
                    emptyListTxt={'List is empty, sorry'}
                    className="min-w-[500px]"
                    count={serial_numbers.length}
                />
            </div>
        </div>
    );
};

export { UploadConfirmationPDF };
